import { OrderedTimeQueryModel } from '../query_models/ordered_time_query_model';
import { PhxCalendarConfiguration } from '../config/calendar_configuration';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import {
  ITransaction,
  IExternalActionTimeSlot,
  TransactionTypeEnum,
  IExternalActionResponse
} from '../external_actions/transaction_types';

function externalActionCommandDefinition(
  defineCommand: any,
  ngPhxCalendarConfiguration: PhxCalendarConfiguration,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  ngOrderedTimeQueryModel: OrderedTimeQueryModel
): ITransaction {
  return defineCommand('externalActionCommand', function externalActionCommand(deferred: ng.IDeferred<any>): void {
    // TODO alias type id = number | string
    const assignId = (saveResponse: ng.IPromise<IExternalActionResponse>, trackingId: string) => {
      if (!saveResponse || !trackingId) {
        return;
      }
      saveResponse.then((response: IExternalActionResponse) => {
        let workingTime = _.find(
          ngTimeOccurrenceDataSource.store,
          (timeSlot: ITimeOccurrenceDatatype) => parseInt(timeSlot.trackingId, 10) === parseInt(trackingId, 10)
        );
        if (_.isUndefined(workingTime)) {
          workingTime = _.last(ngTimeOccurrenceDataSource.store);
        }
        workingTime.id = response.id;
        deferred.resolve();
      });
    };

    let transactionType: TransactionTypeEnum;

    if (ngTimeOccurrenceDataSource.store.length > ngTimeOccurrenceDataSource.memento.length) {
      transactionType = TransactionTypeEnum.SAVE;
    } else if (ngTimeOccurrenceDataSource.store.length < ngTimeOccurrenceDataSource.memento.length) {
      transactionType = TransactionTypeEnum.DELETE;
    } else {
      transactionType = TransactionTypeEnum.EDIT;
    }

    const createExternalActionTimeSlotForTimeOccurrence = (
      timeOccurrence: ITimeOccurrenceDatatype
    ): IExternalActionTimeSlot => {
      return {
        id: timeOccurrence.id,
        trackingId: timeOccurrence.trackingId,
        save: {
          day_of_week: timeOccurrence.day.value.ordinal,
          from_tm: timeOccurrence.fromInput,
          to_tm: timeOccurrence.toInput
        }
      };
    };

    let transactionMade = {
      type: transactionType,
      toAdd: _.map(
        _.difference(ngTimeOccurrenceDataSource.store, ngTimeOccurrenceDataSource.memento),
        createExternalActionTimeSlotForTimeOccurrence
      ),
      toDelete: _.map(
        _.difference(ngTimeOccurrenceDataSource.memento, ngTimeOccurrenceDataSource.store),
        createExternalActionTimeSlotForTimeOccurrence
      )
    };

    if (transactionMade.type === TransactionTypeEnum.SAVE || transactionMade.type === TransactionTypeEnum.DELETE) {
      _.each(transactionMade.toAdd, (time) => {
        assignId(ngPhxCalendarConfiguration.save({ transaction: time }), time.trackingId);
      });

      _.each(transactionMade.toDelete, (time) => {
        ngPhxCalendarConfiguration.delete({ transaction: time });
        deferred.resolve();
      });
    } else if (transactionMade.type === TransactionTypeEnum.EDIT) {
      const transactionsToMake: IExternalActionTimeSlot[] = _.zipWith<IExternalActionTimeSlot>(
        transactionMade.toDelete,
        transactionMade.toAdd,
        _.merge
      );

      _.each(transactionsToMake, (time: IExternalActionTimeSlot) => {
        // NOTE duplicate code on 63
        assignId(ngPhxCalendarConfiguration.edit({ transaction: time }), time.trackingId);
      });

      // TODO how else do we resolve/reject if this fails?
      if (_.isEmpty(transactionsToMake)) {
        deferred.resolve();
      }
    }
  });
}

angular.module('ui-ng-calendar').factory('externalActionCommand', externalActionCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/external_action.ts